import React from "react";
import "./Review.scss";
const sectionHeading = {
    companyInformation: "Company Information",
    companySummary: "Company Summary",
    proposalDetails: "Proposal Details",
    documentUploadFieldGroup: "Documents",
};

const getSelectDisplayValue = (field, value) => {
    const selectedOption = field.options?.find(
        (option) =>
            option.value === value ||
            option.reference === value ||
            option.label?.en_US === value
    );

    return selectedOption?.label?.en_US || selectedOption?.reference || value;
};

const Review = ({ sections, formData, documents }) => {
    return (
        <div className="review-container">
            {sections.map((section) => {
                // Don't render the document section here
                if (section.fieldReference === "documentUploadFieldGroup") {
                    return null;
                }

                // Only keep fields that have a value
                const filledFields =
                    section.nestedFields?.filter((field) => {
                        const value = formData[field.fieldReference];

                        return (
                            !field.hideField &&
                            value !== undefined &&
                            value !== null &&
                            value.toString().trim() !== ""
                        );
                    }) || [];

                // Don't render empty sections
                if (filledFields.length === 0) {
                    return null;
                }

                return (
                    <div
                        key={section.fieldReference}
                        className="review-section"
                    >
                        <h3 className="review-heading">
                            {sectionHeading[section.fieldReference] ||
                                section.label?.en_US}
                        </h3>

                        {filledFields.map((field) => (
                            <div
                                key={field.fieldReference}
                                className="review-row"
                            >
                                <span className="review-label">
                                    {field.label?.en_US}
                                </span>

                                <span className="review-value">
                                    {field.type === "select" || field.type === "dropdown"
                                        ? getSelectDisplayValue(field, formData[field.fieldReference])
                                        : formData[field.fieldReference]}
                                </span>
                            </div>
                        ))}
                    </div>
                );
            })}

            <div className="review-section">
                <h3 className="review-heading">Documents</h3>

                {documents.length > 0 ? (
                    documents.map((file, index) => (
                        <div
                            key={index}
                            className="review-row review-document-row"
                        >
                            <span className="review-value review-document-name">
                                {file.name}
                            </span>
                        </div>
                    ))
                ) : (
                    <p className="review-empty-message">
                        No documents uploaded.
                    </p>
                )}
            </div>
        </div>
    );
};
export default Review;